import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";
import { Download, Trash2, IdCard } from "lucide-react";

export default function Library() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/idcards");
      setItems(data);
    } catch { toast.error("Load failed"); } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const download = async (c, format) => {
    try {
      const res = await api.get(`/idcards/${c.id}/download?format=${format}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `${c.person_name}.${format}`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Download failed"); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete this card?")) return;
    await api.delete(`/idcards/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="space-y-6" data-testid="library-page">
      <div>
        <div className="font-mono text-xs uppercase tracking-widest text-[#002FA7] font-bold mb-2">// Library</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">All ID Cards</h1>
      </div>

      {loading ? (
        <div className="font-mono">Loading...</div>
      ) : items.length === 0 ? (
        <div className="bg-white brutal-border brutal-shadow p-12 text-center">
          <IdCard className="w-12 h-12 mx-auto mb-4 text-[#002FA7]"/>
          <h3 className="font-display font-bold text-2xl mb-2">No cards yet</h3>
          <p className="text-gray-600">Create a template and generate your first card.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map(c => (
            <div key={c.id} className="bg-white brutal-border brutal-shadow flex flex-col" data-testid={`card-${c.id}`}>
              <div className="aspect-[16/10] bg-[#E5E7EB] border-b-2 border-black overflow-hidden flex items-center justify-center">
                <img src={fileUrl(c.png_path)} alt={c.person_name} className="max-h-full max-w-full object-contain"/>
              </div>
              <div className="p-3 flex-1">
                <div className="font-display font-bold text-lg truncate">{c.person_name}</div>
                <div className="font-mono text-[10px] text-gray-500 uppercase truncate">{c.template_name}</div>
                <div className="font-mono text-[10px] text-gray-400">{new Date(c.created_at).toLocaleDateString()}</div>
              </div>
              <div className="grid grid-cols-3 border-t-2 border-black">
                <button onClick={()=>download(c,"png")} className="p-2 hover:bg-black hover:text-white border-r-2 border-black flex items-center justify-center gap-1 font-mono text-[10px] uppercase font-bold" data-testid={`dl-png-${c.id}`}>
                  <Download className="w-3 h-3"/> PNG
                </button>
                <button onClick={()=>download(c,"pdf")} className="p-2 hover:bg-[#002FA7] hover:text-white border-r-2 border-black flex items-center justify-center gap-1 font-mono text-[10px] uppercase font-bold" data-testid={`dl-pdf-${c.id}`}>
                  <Download className="w-3 h-3"/> PDF
                </button>
                <button onClick={()=>del(c.id)} className="p-2 hover:bg-[#FF3B30] hover:text-white flex items-center justify-center font-mono text-[10px] uppercase font-bold" data-testid={`del-card-${c.id}`}>
                  <Trash2 className="w-3 h-3"/>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
